import { useParams } from 'react-router-dom';
import Panel from '../../../../common/layout/Panel'
import DataResource from '../../../../common/v4/DataResource';

const ClientAccountSmppAccounts = () => {
    const { account_id } = useParams();
    const data = {
        url: `/admin/clients/clients/${account_id}/smppaccounts`,
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        onclick: 'link',
        link: `/clients/clients/${account_id}/smppaccounts/{id}`,
        metadata: [
            {
                source: 'ATRSMPPACCOUNTID',
                label: 'SMPP Account ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'ATRUSERNAME',
                label: 'Username',
                type: 'text',
            },
            {
                source: 'ATRPRODUCTID',
                label: 'Rate Profile',
                type: 'select',
            },
            {
                source: 'ATRBIND',
                label: 'Bind Type',
                type: 'text',
            },
            {
                source: 'ATRSTATUS',
                label: 'Enabled',
                type: 'boolean',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    return (
       <Panel title = "SMPP Accounts">
            <DataResource
                addButtonText = "Create SMPP Account"
                addButtonLink = {`/clients/clients/${account_id}/smppaccounts/create`}                    
                data = {data}
            />
        </Panel>
    )
}

export default ClientAccountSmppAccounts;